import {createSelector} from '@ngrx/store';

import {AppState} from '../app-state';
import {Lens} from '../../../lenses/shared/model/lens';

export const selectLensesState = (state: AppState) => state.lenses;

export const selectLenses = createSelector(selectLensesState, state => state.lenses);

export const selectLensesMap = createSelector(
  selectLenses,
  lenses => lenses?.reduce((lensesMap: Record<string, Lens>, obj: Lens) => ((lensesMap[obj._id] = obj), lensesMap), {})
);

export const selectSingleLens = createSelector(selectLensesState, state => state.lens);

export const selectUserLens = createSelector(selectLensesState, state => state.userLens);
